var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 538,
    height: 142,
    viewBox: "0 0 538 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -60,
    y: -76,
    width: 658,
    height: 262
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(50px)",
      clipPath: "url(#bgblur_0_416_3457_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_416_3457)",
    "data-figma-bg-blur-radius": 100
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 24,
    width: 458,
    height: 62,
    rx: 31,
    fill: "url(#paint0_linear_416_3457)",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_416_3457)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_416_3457)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 55,
    r: 15,
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 55,
    r: 14.4598,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.08043
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71,
    filter: "url(#filter2_i_416_3457)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 63,
    r: 17,
    fill: "#FFDD33"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_416_3457)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 65,
    r: 11,
    fill: "#FFDD33"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.5326 63L101.9 47.9304H104.156V50.677H103.362L99.3627 63H96.5326ZM99.2478 59.1047L99.958 57.0265H106.861L107.582 59.1047H99.2478ZM107.477 63L103.488 50.677V47.9304H104.939L110.297 63H107.477ZM116.312 63.2298C115.351 63.2298 114.523 63.0905 113.827 62.812C113.13 62.5266 112.584 62.1332 112.187 61.6319C111.79 61.1307 111.553 60.5493 111.477 59.8879V59.8253H114.046L114.056 59.8879C114.175 60.3196 114.422 60.6642 114.798 60.9218C115.181 61.1794 115.696 61.3082 116.343 61.3082C116.775 61.3082 117.148 61.249 117.461 61.1307C117.774 61.0123 118.018 60.8522 118.192 60.6503C118.373 60.4414 118.463 60.1977 118.463 59.9192V59.8984C118.463 59.5642 118.338 59.2892 118.087 59.0733C117.837 58.8575 117.412 58.68 116.813 58.5407L114.965 58.1335C114.248 57.9733 113.653 57.754 113.179 57.4755C112.706 57.1901 112.351 56.8385 112.114 56.4208C111.884 56.003 111.769 55.5192 111.769 54.9692V54.9587C111.769 54.2695 111.957 53.6672 112.333 53.152C112.716 52.6368 113.245 52.2365 113.921 51.9511C114.603 51.6586 115.39 51.5124 116.281 51.5124C117.2 51.5124 117.99 51.6586 118.651 51.9511C119.32 52.2435 119.838 52.6403 120.207 53.1416C120.576 53.6359 120.782 54.1964 120.824 54.8229V54.8856H118.39L118.38 54.8334C118.303 54.4365 118.084 54.1058 117.722 53.8413C117.367 53.5698 116.883 53.434 116.27 53.434C115.887 53.434 115.55 53.4932 115.257 53.6115C114.965 53.7229 114.739 53.8831 114.579 54.0919C114.418 54.2938 114.338 54.534 114.338 54.8125V54.8229C114.338 55.0388 114.391 55.2302 114.495 55.3973C114.606 55.5644 114.784 55.7106 115.028 55.8359C115.271 55.9613 115.592 56.0727 115.988 56.1701L117.837 56.5774C118.965 56.828 119.786 57.197 120.301 57.6844C120.817 58.1717 121.074 58.8262 121.074 59.6477V59.6582C121.074 60.3683 120.869 60.9914 120.458 61.5275C120.054 62.0636 119.494 62.4813 118.777 62.7807C118.06 63.0801 117.238 63.2298 116.312 63.2298ZM123.382 63V47.5022H125.983V63H123.382ZM130.473 63L126.693 57.8828L128.51 56.1597L133.543 63H130.473ZM125.69 59.3658L125.638 56.379H126.108L130.296 51.7422H133.293L128.249 57.1205L127.361 57.6426L125.69 59.3658ZM144.185 63V50.1966H139.6V47.9304H151.454V50.1966H146.869V63H144.185ZM154.451 63.188C153.72 63.188 153.072 63.0487 152.508 62.7702C151.951 62.4848 151.513 62.088 151.192 61.5797C150.872 61.0715 150.712 60.4797 150.712 59.8044V59.7835C150.712 59.1151 150.879 58.5407 151.213 58.0604C151.548 57.58 152.031 57.2005 152.665 56.922C153.306 56.6436 154.082 56.4765 154.994 56.4208L159.223 56.1701V57.8828L155.359 58.1335C154.67 58.1683 154.151 58.3214 153.803 58.593C153.462 58.8575 153.292 59.2161 153.292 59.6686V59.6895C153.292 60.1629 153.469 60.5354 153.824 60.8069C154.186 61.0715 154.656 61.2038 155.234 61.2038C155.742 61.2038 156.198 61.1028 156.602 60.9009C157.006 60.692 157.323 60.4101 157.552 60.055C157.789 59.6999 157.907 59.2996 157.907 58.854V55.366C157.907 54.8021 157.726 54.3634 157.364 54.0501C157.009 53.7369 156.491 53.5802 155.808 53.5802C155.203 53.5802 154.712 53.6951 154.336 53.9248C153.967 54.1546 153.727 54.4644 153.615 54.8543L153.594 54.9169H151.161L151.172 54.8125C151.248 54.165 151.485 53.5941 151.882 53.0998C152.286 52.6055 152.829 52.2191 153.511 51.9406C154.2 51.6552 155.004 51.5124 155.923 51.5124C156.877 51.5124 157.695 51.6656 158.377 51.9719C159.06 52.2783 159.582 52.7134 159.944 53.2774C160.313 53.8413 160.497 54.5097 160.497 55.2825V63H157.907V61.3709H157.782C157.573 61.7468 157.302 62.0706 156.968 62.3421C156.64 62.6136 156.261 62.8225 155.829 62.9687C155.405 63.1149 154.945 63.188 154.451 63.188ZM163.171 63V51.7422H165.771V53.5593H165.897C166.078 52.9188 166.405 52.421 166.878 52.0659C167.359 51.7109 167.95 51.5333 168.654 51.5333C168.835 51.5333 169.009 51.5438 169.176 51.5647C169.35 51.5855 169.496 51.6134 169.614 51.6482V53.9875C169.447 53.9388 169.263 53.9039 169.061 53.8831C168.859 53.8552 168.643 53.8413 168.413 53.8413C167.877 53.8413 167.411 53.9457 167.014 54.1546C166.617 54.3634 166.311 54.6628 166.095 55.0527C165.879 55.4426 165.771 55.9125 165.771 56.4625V63H163.171ZM174.376 63.188C173.645 63.188 172.998 63.0487 172.434 62.7702C171.877 62.4848 171.438 62.088 171.118 61.5797C170.798 61.0715 170.638 60.4797 170.638 59.8044V59.7835C170.638 59.1151 170.805 58.5407 171.139 58.0604C171.473 57.58 171.957 57.2005 172.591 56.922C173.231 56.6436 174.007 56.4765 174.92 56.4208L179.149 56.1701V57.8828L175.285 58.1335C174.596 58.1683 174.077 58.3214 173.729 58.593C173.388 58.8575 173.217 59.2161 173.217 59.6686V59.6895C173.217 60.1629 173.395 60.5354 173.75 60.8069C174.112 61.0715 174.582 61.2038 175.16 61.2038C175.668 61.2038 176.124 61.1028 176.528 60.9009C176.932 60.692 177.248 60.4101 177.478 60.055C177.715 59.6999 177.833 59.2996 177.833 58.854V55.366C177.833 54.8021 177.652 54.3634 177.29 54.0501C176.935 53.7369 176.416 53.5802 175.734 53.5802C175.128 53.5802 174.638 53.6951 174.262 53.9248C173.893 54.1546 173.652 54.4644 173.541 54.8543L173.52 54.9169H171.087L171.097 54.8125C171.174 54.165 171.411 53.5941 171.807 53.0998C172.211 52.6055 172.754 52.2191 173.437 51.9406C174.126 51.6552 174.93 51.5124 175.849 51.5124C176.803 51.5124 177.621 51.6656 178.303 51.9719C178.985 52.2783 179.508 52.7134 179.87 53.2774C180.239 53.8413 180.423 54.5097 180.423 55.2825V63H177.833V61.3709H177.708C177.499 61.7468 177.227 62.0706 176.893 62.3421C176.566 62.6136 176.187 62.8225 175.755 62.9687C175.33 63.1149 174.871 63.188 174.376 63.188Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_416_3457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.171 43.8284C471.897 43.5534 471.553 43.3567 471.177 43.2585C470.801 43.1602 470.405 43.164 470.031 43.2695L470.007 43.2772L449.017 49.6406C448.591 49.7641 448.213 50.014 447.932 50.3572C447.652 50.7004 447.482 51.1207 447.446 51.5624C447.41 52.0042 447.508 52.4466 447.729 52.8309C447.95 53.2153 448.282 53.5236 448.682 53.7148L457.828 58.1719L462.281 67.3211C462.456 67.6945 462.735 68.01 463.084 68.2305C463.432 68.451 463.837 68.5673 464.249 68.5658C464.312 68.5658 464.375 68.5658 464.439 68.5581C464.882 68.524 465.303 68.3547 465.647 68.073C465.99 67.7913 466.239 67.4108 466.359 66.9831L472.723 45.993C472.726 45.9852 472.729 45.9771 472.73 45.9689C472.836 45.5947 472.84 45.199 472.741 44.8228C472.643 44.4466 472.446 44.1033 472.171 43.8284ZM464.162 65.1795L460.403 57.4533L465.434 52.4275C465.556 52.3054 465.653 52.1605 465.719 52.001C465.785 51.8414 465.819 51.6705 465.819 51.4978C465.819 51.3252 465.785 51.1542 465.719 50.9947C465.653 50.8352 465.556 50.6902 465.434 50.5681C465.312 50.446 465.167 50.3492 465.007 50.2831C464.848 50.217 464.677 50.183 464.504 50.183C464.332 50.183 464.161 50.217 464.001 50.2831C463.842 50.3492 463.697 50.446 463.575 50.5681L458.543 55.5994L450.82 51.838L469.969 46.0313L464.162 65.1795Z",
    fill: "#98A2B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_416_3457",
    x: -60,
    y: -76,
    width: 658,
    height: 262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.333333 0 0 0 0 0.411765 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_3457"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "BackgroundImageFix",
    in2: "effect1_dropShadow_416_3457",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_416_3457_clip_path",
    transform: "translate(60 76)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 24,
    width: 458,
    height: 62,
    rx: 31
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_416_3457",
    x: 47.5,
    y: 35.5,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.714243 0 0 0 0 0.612403 0 0 0 0 0.103204 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_3457"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_416_3457",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.65098 0 0 0 0 0.105882 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_416_3457"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_416_3457",
    x: 54,
    y: 46,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.03636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_416_3457"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_416_3457",
    x: 46.4,
    y: 39.4,
    width: 49.2,
    height: 49.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.737255 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_3457"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_416_3457",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_416_3457"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_416_3457",
    x: 447,
    y: 41,
    width: 28,
    height: 31.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_416_3457"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_416_3457",
    x1: 269,
    y1: 55,
    x2: 269,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_416_3457"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 40,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInput);
export default __webpack_public_path__ + "static/media/search-input.fe72fb88304b205bae830beb4acd57c9.svg";
export { ForwardRef as ReactComponent };